import FoldersView from './FolderView'
export default FoldersView
